/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { GetDataFirstStage200ResponseData } from './GetDataFirstStage200ResponseData'
import {
  GetDataFirstStage200ResponseDataFromJSON,
  GetDataFirstStage200ResponseDataFromJSONTyped,
  GetDataFirstStage200ResponseDataToJSON,
} from './GetDataFirstStage200ResponseData'

/**
 *
 * @export
 * @interface GetDataFirstStage200Response
 */
export interface GetDataFirstStage200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetDataFirstStage200Response
   */
  status: boolean
  /**
   *
   * @type {GetDataFirstStage200ResponseData}
   * @memberof GetDataFirstStage200Response
   */
  data: GetDataFirstStage200ResponseData
}

/**
 * Check if a given object implements the GetDataFirstStage200Response interface.
 */
export function instanceOfGetDataFirstStage200Response(
  value: object
): value is GetDataFirstStage200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetDataFirstStage200ResponseFromJSON(
  json: any
): GetDataFirstStage200Response {
  return GetDataFirstStage200ResponseFromJSONTyped(json, false)
}

export function GetDataFirstStage200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetDataFirstStage200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: GetDataFirstStage200ResponseDataFromJSON(json['data']),
  }
}

export function GetDataFirstStage200ResponseToJSON(
  value?: GetDataFirstStage200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: GetDataFirstStage200ResponseDataToJSON(value['data']),
  }
}
